import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';

export class CacheUpdateEvent implements IEvent {
  public constructor(init?: Partial<CacheUpdateEvent>) {
    (Object as any).assign(this, init);
  }
}
